export default {
  isType (identifier) {
    return identifier === 'bool'
  }
}
